import React from 'react';
import { useRippleEffect } from '../hooks/useRippleEffect';
import './About.css';

export const About: React.FC = () => {
  const { ripples, createRipple } = useRippleEffect();

  return (
    <section id="about" className="about" onClick={createRipple}>
      <div className="about-container">
        {/* About Us Section - Full Width */}
        <div className="about-text-section">
          <h2 className="about-title">
            About <span className="title-highlight">Intelyx</span>
          </h2>
          <div className="about-description">
            <p>
              At Intelyx, we believe businesses deserve insights that go deeper than surface-level signals. 
              While traditional AI models like cosine similarity or Alternating Least Squares can suggest what customers might want, 
              they often fall short of capturing true needs.
            </p>
            <p>
              At Intelyx we built <span className="spotton-brand-text">Spott-on</span> to bridge that gap—helping you understand what your customers really need 
              and empowering your team with tailored strategies that create lasting impact.
            </p>
            <div className="mission-statement">
              <h3 className="mission-title">Our Mission</h3>
              <p className="mission-text">
                Help B2B distribution companies connect with customers in ways that matter—backed by accuracy that drives real impact.
              </p>
            </div>
          </div>
        </div>



        {/* Founders Section */}
        <div className="founders-section">
          <h3 className="founders-title">Leadership Team</h3>
          <div className="founders-grid">
            {/* Suresh K Saridey - Co-Founder & CTO */}
            <div className="founder-card">
              <div className="founder-image">
                <img src="/suresh.jpg" alt="Suresh K Saridey - Co-Founder" />
              </div>
              <div className="founder-info">
                <h4 className="founder-name">Suresh K Saridey</h4>
                <p className="founder-title">Co-Founder</p>
              </div>
            </div>

            {/* Anuradha Dasari - Co-Founder & COO */}
            <div className="founder-card">
              <div className="founder-image">
                <img src="/anuradha.jpg" alt="Anuradha Dasari - Co-Founder" />
              </div>
              <div className="founder-info">
                <h4 className="founder-name">Anuradha Dasari</h4>
                <p className="founder-title">Co-Founder</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Ripple effects */}
      {ripples.map(ripple => (
        <div
          key={ripple.id}
          className="section-ripple"
          style={{
            left: ripple.x,
            top: ripple.y,
          }}
        >
          <div className="ripple-ring ring-1"></div>
          <div className="ripple-ring ring-2"></div>
          <div className="ripple-ring ring-3"></div>
        </div>
      ))}
    </section>
  );
};